// extracted by mini-css-extract-plugin
module.exports = {"viewAll":"FeaturesList_viewAll__L_Ta9","retailValue":"FeaturesList_retailValue__Cr9Ub"};